<template>
  <div id="passage_container">
    <b-row>
      <b-col md="4">
        <b-form-select v-model="courseFilter" :options="passages.list_courses" @input="changeSelectedLiveCourse"
          size="sm"></b-form-select>
      </b-col>
      <b-col md="4" style="text-align: left">
        <b-button-group>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = ''"
            v-bind:class="{ sex_selected_button: sexeFilter === '' }">
            <v-icon name="male" />
            <v-icon name="female" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'M'"
            v-bind:class="{ sex_selected_button: sexeFilter === 'M' }">
            <v-icon name="male" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'F'"
            v-bind:class="{ sex_selected_button: sexeFilter === 'F' }">
            <v-icon name="female" />
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row>
      <!-- <ProfilPassages style="margin-top: 20px" v-if="lines.length > 0 && passages.parcours" :lines="lines"
        :parcours="passages.parcours"></ProfilPassages> -->
      <b-col style="margin-top: 25px" md="12" v-for="(point, index_po) in passages.points" :key="index_po">
        <h3 class="align_left">
          <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
          <span v-if="point.nom != 'Arrivée'">KM {{ point.distance_depuis_depart }} -</span> {{ point.nom }}
        </h3>
        <TableauPassages v-if="point.passages.length > 0" :coureurs="point.passages" :sexeFilter="sexeFilter"
          :index_po="index_po" :key="courseFilter + point.nom"></TableauPassages>
        <div v-else class="text-left">
          En attente des premiers passages ...
        </div>
        <b-button size="sm" class="button_select_fav inline-submenu-btn" @click="loadMore(point)">Voir
          tous les
          passages de {{ point.nom }}</b-button>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import TableauPassages from "@/components/Live_tab/TableauPassages.vue";
import ProfilPassages from "@/components/Live_tab/ProfilPassages.vue";
import Loading from "@/components/Loading.vue";
import toGeoJSON from "@mapbox/togeojson/togeojson.js";

export default {
  components: { TableauPassages, Loading, ProfilPassages },
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lines: [],
      passages: {},
      load_all: false,
      courseFilter: "",
      sexeFilter: "",
      passages_profil: {},
      skipCourseFilterWatch: false,
      allPassagesAtSelectedPoint: [],
    };
  },

  watch: {
    courseFilter() {
      if (this.skipCourseFilterWatch) return;
      this.fetchPassages();
    },

    sexeFilter() {
      if (this.skipCourseFilterWatch) return;
      this.fetchPassages();
    },
  },

  methods: {
    changeSelectedLiveCourse(c) {
      this.$store.commit("setLoading");
      this.load_all = false;
      this.$store.state.selected_live_course = this.courseFilter;
    },
    loadMore(point) {
      this.load_all = true;

      var _this = this;
      var endpoint = this.buildEndpoint(point.nom);
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        _this.$store.commit("unsetLoading");
        console.log("LIVE -- Fetch passages ");
        _this.allPassagesAtSelectedPoint = response.data;
        for (let i = 0; i < _this.passages.points.length; i++) {

          if (_this.passages.points[i].nom === point.nom) {
            _this.passages.points[i].passages = _this.allPassagesAtSelectedPoint.points[0].passages;
            break;
          }
        }
        _this.$forceUpdate();
      }).catch(function (error) {
        console.error("Error fetching passages: ", error);
      });
    },
    buildEndpoint(pointName = null) {
      var url = "/live/passages/get.php?id=" + this.$store.state.module.id + "&base=" + this.$store.state.module.base;
      if (this.courseFilter != "") {
        url += "&course=" + encodeURIComponent(this.courseFilter);
      }
      if (this.sexeFilter != "") {
        url += "&sexe=" + this.sexeFilter;
      }
      if (pointName) {
        url += "&point=" + encodeURIComponent(pointName);
      }
      return url;
    },
    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.fetchPassages();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_live);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
    fetchPassages() {
      console.trace("fetchPassages");
      var _this = this;
      var endpoint = this.buildEndpoint();
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        _this.$store.commit("unsetLoading");
        console.log("LIVE -- Fetch passages ");
        _this.passages = response.data;
        if (_this.courseFilter === "") {
          _this.skipCourseFilterWatch = true;
          _this.courseFilter = _this.passages.list_courses[0];
          _this.$nextTick(() => { _this.skipCourseFilterWatch = false; });
        }
        if (_this.passages.timestamp_depart) {
          _this.$store.state.date_selected_course = _this.passages.timestamp_depart.date_course;
          _this.$store.state.heure_selected_course = _this.passages.timestamp_depart.heure_depart;
          _this.$store.state.fin_selected_course = _this.passages.timestamp_depart.course_finie;
        }
        /* if (!_this.passages_profil.nom || _this.passages_profil.nom != _this.passages.parcours.nom) {
          _this.passages_profil = _this.passages.parcours;
          _this.loadGeoJSON();
          _this.$forceUpdate();
        } */
      });
    },
    loadGeoJSON() {
      var _this = this;
      _this.lines = {};
      axios.get("https://sportips.fr/live/" + this.passages.parcours.trace).then(function (response) {
        _this.geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
        if (_this.geojson.features.length > 0) {
          _this.lines = _this.geojson.features[0].geometry.coordinates;
        }
      });
    },
  },
  created() {
    this.$store.commit("clearRefreshIntervals");
    if (this.$route.params.course && this.$route.params.course != "") {
      this.courseFilter = this.$route.params.course;
      this.$store.state.selected_live_course = this.courseFilter;
    } else if (this.$store.state.selected_live_course && this.$store.state.selected_live_course != "") {
      this.courseFilter = this.$store.state.selected_live_course;
    }
    this.fetchPassages();
    //this.countdownRefresh();
  },
};
</script>

<style lang="sass" scoped>
</style>